import {
    Calendar ,
    CalendarProps,
    momentLocalizer,
  } from "react-big-calendar";
  import moment from "moment";
  import 'react-big-calendar/lib/css/react-big-calendar.css';
  
  const localizer = momentLocalizer(moment);
  
  export default function BigCalendar(props: Omit<CalendarProps, "localizer">) {
    return <Calendar {...props} localizer={localizer} />;
  }